import React, { useEffect } from "react";
import styles from "./style.module.css";
import Navbar from "../../components/Navbar/Navbar";
import { images } from "../../assets/images";
import DownloadButton from "../../components/DownloadButton";
import JoinCommunity from "./components/JoinCommunity";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import Testmonials from "./components/Testmonials";
import Events from "./components/Events";
import ImageCraousel from "./components/ImageCraousel";
import ConnectCard2 from "./components/ConnectCard2";
const CommunityScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);
  const { Apple, PlayStore } = images;
  return (
    <div className={styles.pageContainer}>
      <Navbar text="Login/Sign In" />
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.heading}>
            Join <span className={styles.span}>India's</span> pioneering Real
            Estate community
          </h1>
          <p className={styles.desc}>
            Welcome to India's premier Real Estate hub. Join our community to
            connect, learn, and grow. Unlock Opportunities, Connect with
            Experts, Elevate Your Real Estate Journey!
          </p>
          <div className={styles.buttonContainer}>
            <DownloadButton icon={Apple} text="Download on App Store" />
            <DownloadButton icon={PlayStore} text="Download on Play Store" />
          </div>
        </div>
      </div>
      <div className={styles.imgContainer}>
        {/* <img src={Community} alt="Community" className={styles.img} /> */}
        <ImageCraousel />
      </div>
      {/* <ConnectCard />  */}
      <ConnectCard2 />
      <JoinCommunity />
      <Events />
      <Testmonials />
      <Banner
        text="Supercharge your Property Businesses with Avasify"
        backgroundColor="#8e2d8d"
      />
      <Footer />
    </div>
  );
};

export default CommunityScreen;
